// extracted by mini-css-extract-plugin
module.exports = {"page-tab":"tabs_page-tab__Uf4uh","active":"tabs_active__3IcAw"};